import { Box, Flex } from '@radix-ui/themes';
import React from 'react';

export const WorkExperience = () => {
    return <Box>WorkExperience</Box>;
};
